class MarkupModal extends HTMLElement {
  constructor() {
    super();

    this.innerWrapper = this.querySelector("[data-inner-wrapper]");
    this.inner = this.querySelector("[data-inner]");
    this.content = this.querySelector("[data-content]");
    this.loadingContent = this.querySelector("[data-loading]");
    this.swipeClose = this.querySelector("[data-swipe-close]");

    this.handleOpen = (e) => {
      if (e.detail.target !== this.id) return;

      this.focusOnClose = e.target;

      if (e.detail.closeOthers) {
        document.dispatchEvent(
          new CustomEvent("markup-modal:close", {
            detail: { except: this.id },
          }),
        );
      }
      console.log(`e.detail`, e.detail);
      if (e.detail.customData) {
        this._setCustomData(e.detail.customData);
      } else {
        this._removeCustomData();
      }

      this._open(e.detail.html);
    };

    this.handleClose = (e) => {
      if (e.detail?.except === this.id) return;

      this._close();
    };

    this.handleDocumentClick = (e) => {
      // Ignore clicks on items within an old modal.
      if (!document.body.contains(e.target)) return;

      if (this._isOpen && !this.inner.contains(e.target)) {
        this._close();
      }
    };

    this.handleKeyUp = (e) => {
      if (this._isOpen && e.code.toUpperCase() === "ESCAPE") {
        this._close();
      }
    };

    document.addEventListener("markup-modal:open", this.handleOpen);
    document.addEventListener("markup-modal:close", this.handleClose);
    document.addEventListener("click", this.handleDocumentClick);
    document.addEventListener("keyup", this.handleKeyUp);
    this.addEventListener("click", (e) => {
      if (!e.target.closest("[data-close]")) return;

      this._close();
    });

    if (this.swipeClose) {
      this.swipeClose.addEventListener("click", () => {
        if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
          this._close();
        }
      });

      this.swipeClose.addEventListener("touchstart", (e) => {
        this.touchstart = e.targetTouches[0].clientY;
        this.touchend = null;

        console.log(`this.touchStart`, this.touchStart);
      });

      this.addEventListener("touchmove", (e) => {
        if (!this.touchstart) return;

        this.touchend = e.targetTouches[0].clientY;
        this._setSwipeOffset(Math.max(0, this.touchend - this.touchstart));
      });

      this.addEventListener("touchend", () => {
        if (this.touchend && this.touchend - this.touchstart > 50) {
          this._close();
        } else {
          this._setSwipeOffset(0);
        }
      });
    }
  }

  disconnectedCallback() {
    document.removeEventListener("markup-modal:open", this.handleOpen);
    document.removeEventListener("markup-modal:close", this.handleClose);
    document.removeEventListener("click", this.handleDocumentClick);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  _showState(state) {
    if (!this.loadingContent) return;

    const isLoading = state === "loading";

    this.loadingContent.style.display = isLoading ? null : "none";
    this.content.style.display = isLoading ? "none" : null;
  }

  _setContent(html) {
    if (typeof html === "string") {
      this.content.innerHTML = html;
    } else {
      this.content.append(html);
    }

    this._showState("loaded");
  }

  _loadStylesheets() {
    const template = this.querySelector("[data-stylesheets]");

    if (!template) return;

    document.body.append(template.content);

    template.remove();
  }

  _open(html) {
    this._loadStylesheets();

    if (html instanceof Promise) {
      this._showState("loading");
    } else {
      this._setContent(html);
    }

    this.style.display = null;
    window.openFullDimmer(this);

    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      this._isOpen = true;
      window.lockScroll(this);
      window.trapFocus(this, this.querySelector("[data-close]"));
      document.body.classList.add("markup-modal-open");
      if (html instanceof Promise) {
        html.then((html) => {
          if (!this._isOpen) return;
          this._setContent(html);
        });
      }
    });
  }

  _close() {
    if (!this._isOpen) return;

    const handleTransitionEnd = () => {
      this.removeEventListener("transitionend", handleTransitionEnd);
      this._setContent("");
      this._showState("loaded");
      this.innerWrapper.scrollTop = 0;
      this.style.display = "none";
      window.removeTrapFocus(this.focusOnClose);
      window.unlockScroll(this);
      this._isOpen = false;
      this.touchstart = null;
      this.touchend = null;
      this._setSwipeOffset(0);
      this._removeCustomData();
      document.body.classList.remove("markup-modal-open");

      document.dispatchEvent(new CustomEvent("markup-modal:closed"));
    };

    this.addEventListener("transitionend", handleTransitionEnd);
    this.removeAttribute("open");
    window.closeFullDimmer(this);
  }

  _setCustomData(value) {
    this.dataset.customData = value;
  }

  _removeCustomData() {
    delete this.dataset.customData;
  }

  _setSwipeOffset(px) {
    this.style.setProperty("--swipe-offset", `${isFinite(px) ? px : 0}px`);
  }
}

if (!customElements.get("markup-modal")) {
  customElements.define("markup-modal", MarkupModal);
}
